<p-select
  [options]="(fetchCountryStates() | async) ?? []"
  optionLabel="name"
  [filter]="true"
  filterBy="name,isoCode"
  [showClear]="false"
  [placeholder]="placeholder"
  class="w-full"
  [disabled]="disabled"
  [ngModel]="selectedCountryState"
  (ngModelChange)="setCountryState($event)"
  (blur)="onTouched()"
  (change)="onTouched()">
  <ng-template #selectedItem let-selectedOption>
    <div class="country-state flex gap-2">
      <span>{{ selectedOption.name }}</span>
    </div>
  </ng-template>
  <ng-template let-country #item>
    <div class="country-state flex gap-2">
      <span class="country-name">{{ country.name }}</span>
      <div>
        <label i18n="select-country-state|ISO code label">ISO code:</label>
        <span>{{ country.isoCode }}</span>
      </div>
    </div>
  </ng-template>
</p-select>

@if (otherStateFieldVisible) {
  <div class="field other-state-field flex flex-col gap-2 mt-2">
    <label for="otherState" class="block" i18n="country-state-selector|Form label">Other State</label>
    <input
      type="text"
      pInputText
      id="otherState"
      [disabled]="disabled"
      [ngModel]="otherState"
      (ngModelChange)="onOtherStateChange($event)"
      (blur)="onTouched()" />
  </div>
}